import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ColumnOptionsState } from '@shared-features/models/column-options-state.model';
import { ApiBaseService, Mapper } from '@core/services';
import { ApiConstant } from '@shared/constants';
import { map } from 'rxjs/operators';
import { IAiMessage } from '@shared-features/models/ai-message.model';

@Injectable({
  providedIn: 'root',
})
export class AiDrawerService {
  constructor(private baseAPI: ApiBaseService, private mapper: Mapper) {}

  state$ = new Subject<ColumnOptionsState>();
  aiDrawer$ = new Subject();
  sessionId: string;

  toggleDrawer(shown?: boolean): void {
    this.aiDrawer$.next(shown);
  }
  sendAiMessage(message: string): Observable<IAiMessage> {
    const payload = {
      message,
      sessionId: this.sessionId,
    };
    return this.baseAPI.post(ApiConstant.API_SEND_AI_MESSAGE, payload).pipe(
      map((res) => {
        const mapped: IAiMessage = this.mapper.fromJson(IAiMessage, res.data); // need to handle from json to return model not any
        this.sessionId = mapped.sessionId;
        return mapped;
      })
    );
  }
}
